export default "__VITE_ASSET__CHskEoab__"